import {defineStore} from 'pinia';
import {QueryItem} from '@/core/types';
import {SanitizeValue} from '@/core/utils';
import {SmartSearchConfig} from "@/main";

export const useUserRecentQueriesStore = defineStore('userRecentQueries', {
  state: () => ({
    queries: [] as Array<QueryItem>,
    localStorageKey: 'SSv3_userRecentQueries'
  }),
  
  actions: {
    addQuery(query: string) {
      const sanitizedQuery = SanitizeValue(query)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const recentQueriesCount = SmartSearchConfig.value.onfocus.recentQueries.count;
      const newQuery = {query: sanitizedQuery};
      
      setTimeout(()=>{
        this.queries = this.queries.filter(q => q.query !== sanitizedQuery);
        this.queries.unshift(newQuery);
        if (this.queries.length > recentQueriesCount) {
          this.queries.pop();
        }
        this.saveQueries();
      },500)
     
    },
    
    removeQuery(index: number) {
      setTimeout(()=>{
        this.queries.splice(index, 1);
        this.saveQueries();
      },500)
      
    },
    
    clearQueries() {
      this.queries = [];
      this.saveQueries();
    },
    
    saveQueries() {
      const uniqueQueries = Array.from(new Set(this.queries.map(q => JSON.stringify(q)))).map(q => JSON.parse(q));
      localStorage.setItem(this.localStorageKey, JSON.stringify(uniqueQueries));
    },
    
    getQueries() {
      const queriesFromStorage = localStorage.getItem(this.localStorageKey);
      if (queriesFromStorage) {
        
        const parsedQueries = JSON.parse(queriesFromStorage)
        this.queries = parsedQueries.map((item: QueryItem) => {
          return {"query": SanitizeValue(item.query)}
        });
      }
    },
    
  },
  
  getters: {
    hasRecentQueries: (state) => state.queries.length > 0,
    recentQueries: (state) => state.queries,
  },
});
